import React, {Component} from "react";
import {Controller, Scene} from "react-scrollmagic";
import {Timeline, Tween} from "react-gsap";

interface Props {
    onShowAllGames: () => void;
}

export default class AvailableGamesScrollMagic extends Component<Props> {
    render(): JSX.Element {
        return (
            <section className="anywhereTab__games">
                <Controller>
                    <Scene
                        offset={-160}
                        triggerHook="onLeave"
                        duration="100%"
                        pin
                    >
                        <Timeline>
                            <h3 className="section-title">Games available</h3>
                            <div className="anywhereTab__games__container scrollmagic">
                                <Tween to={{x: "-100%"}}>
                                    <ul className="carousel">
                                        <li className="item">Assassin’s Creed Valhalla</li>
                                        <li className="item">Assassin’s Creed Odyssey</li>
                                        <li className="item">Ghost Recon Breakpoint</li>
                                        <li className="item">Far Cry New Dawn</li>
                                        <li className="item">Monopoly Plus</li>
                                        <li className="item">Far Cry Primal</li>
                                        <li className="item">Steep</li>
                                    </ul>
                                </Tween>
                            </div>

                            <button className="btn" onClick={this.props.onShowAllGames}>View all games available</button>
                        </Timeline>
                    </Scene>
                </Controller>
            </section>
        );
    }
}